import React from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography, IconButton, TextField, MenuItem, Button } from '@mui/material';
import { X } from 'lucide-react';
import styles from './GateRequestModal.module.css';
import GateRequestSuccessModal from './GateRequestSuccessModal';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useState } from 'react';
import{convertTo12Hour , convertTo24Hour , convertDateFormat} from './customFunction'

const GateRequestModal = ({ open, onClose, onSubmit, edit = false, selectedData = null, fetchRequests }) => {
  const [form, setForm] = React.useState({
    requestType: '',
    reason: '',
    date: '',
    fromTime: '',
    toTime: '',
    numberOfDays: '',
    fromDate: '',
    toDate: ''
  });

  const [submitting, setSubmitting] = React.useState(false);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [successData, setSuccessData] = React.useState(null);
  const [studentData, setStudentData] = React.useState(null);
  const [fieldErrors, setFieldErrors] = React.useState({});
  const today = new Date();
  console.log("edit value",edit)

  // IST offset in minutes (+5:30)
  const istOffset = 330;
  const istDate = new Date(today.getTime() + istOffset * 60 * 1000 - today.getTimezoneOffset() * 60 * 1000);
  // Convert to IST
  const istTime = today.toLocaleTimeString('en-US', { hour12: false, timeZone: 'Asia/Kolkata' });

  const [hours, minutes] = istTime.split(':');
  const currentTime = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;

  console.log(currentTime); // Correct IST time like "17:10"

  // Current IST date in "YYYY-MM-DD" to compare with form.date
  const currentDate = istDate.toISOString().split('T')[0];

  // Check if form.date is today (IST)
  const isToday = form.date === currentDate;

  console.log(isToday); // true or false

  const currentUser = React.useMemo(() => {
    try {
      const raw = Cookies.get('user');
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }, []);

    // Prevent background scrolling when modal is open
    useEffect(() => {
      if (open) {
        // Save the current scroll position
        const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        
        // Lock root and main elements directly
        const rootElement = document.getElementById('root');
        const mainElement = document.querySelector('main');
        
        if (rootElement) {
          rootElement.style.overflow = 'hidden';
          rootElement.style.height = '100%';
        }
        
        if (mainElement) {
          mainElement.style.overflow = 'hidden';
          mainElement.style.overflowY = 'hidden';
          mainElement.style.overflowX = 'hidden';
        }
        
        // Lock body
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        
        // Cleanup: restore styles when modal closes
        return () => {
          if (rootElement) {
            rootElement.style.overflow = '';
            rootElement.style.height = '';
          }
          
          if (mainElement) {
            mainElement.style.overflow = '';
            mainElement.style.overflowY = '';
            mainElement.style.overflowX = '';
          }
          
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          
          // Restore scroll position
          window.scrollTo(0, scrollY);
        };
      }
    }, [open]);

  React.useEffect(() => {
    if (form.requestType === 'late_entry') {
      setForm((prev) => ({ ...prev, fromTime: currentTime }));
    }
  }, [form.requestType, currentTime]);



  // Populate form when editing
  React.useEffect(() => {
    console.log('Edit modal useEffect:', { edit, selectedData, open, hasId: !!selectedData?._id, hasRequestId: !!selectedData?.requestId });
    if (edit && selectedData && open) {
      const data = selectedData;
      // Map the selected data to form fields
      // Use requestTypeOriginal if available (preserves original format like 'late_entry'), otherwise use requestType
      const requestType = data.requestTypeOriginal || data.requestType || '';
      const reason = data.reason || '';
      
      // Handle date fields - check duration object first, then root level
      const duration = data.duration || {};
      // For early departure, check duration.date first (DD-MM-YYYY format), then root level
      const date = duration.date || data.fromDate || data.toDate || data.date || duration.fromDate || '';
      const fromDate = data.fromDate || duration.fromDate || duration.date || data.date || '';
      const toDate = data.toDate || duration.toDate || duration.toDate || '';
      
      const normalizeMidnight24 = (value) => (String(value || '').trim() === '24:00' ? '00:00' : value);

      // Handle time fields - check root level fields first, then duration object
      let fromTime = '';
      let toTime = '';
      
      // Priority order: root level fields first (most reliable)
      // For early departure and late entry: check toTime at root level
      // For leave: check outTime and inTime at root level
      if (data.toTime) {
        // Root level toTime (for early departure, late entry) - this is the main source
        toTime = normalizeMidnight24(data.toTime);
      } else if (data.fromTime) {
        // Root level fromTime
        fromTime = normalizeMidnight24(data.fromTime);
      } else if (data.outTime) {
        // Root level outTime (for leave)
        fromTime = normalizeMidnight24(data.outTime);
      } else if (data.inTime) {
        // Root level inTime (for leave)
        toTime = normalizeMidnight24(data.inTime);
      } else {
        // Fall back to duration object or time string
        const timeStr = normalizeMidnight24(duration.time || data.time || '');
        if (timeStr && timeStr.trim() !== '') {
          if (timeStr.includes('-')) {
            const timeParts = timeStr.split('-');
            if (timeParts.length === 2) {
              fromTime = normalizeMidnight24(timeParts[0].trim());
              toTime = normalizeMidnight24(timeParts[1].trim());
            }
          } else {
            toTime = normalizeMidnight24(timeStr.trim());
          }
        } else {
          // Check duration object fields
          fromTime = normalizeMidnight24(duration.fromTime || duration.outTime || '');
          toTime = normalizeMidnight24(duration.toTime || duration.inTime || '');
        }
      }
      
      // Convert 12-hour format to 24-hour format for HTML time input
      fromTime = convertTo24Hour(fromTime);
      toTime = convertTo24Hour(toTime);
      
      // Debug log - show full data structure
      console.log('Edit mode - Full data structure:', {
        fullData: data,
        duration: duration,
        hasToTime: !!data.toTime,
        toTimeValue: data.toTime,
        extracted: { date, fromDate, toDate, fromTime, toTime }
      });
      
      const numberOfDays = duration.numberOfDays || data.numberOfDays || '';

      // Determine which date to use based on request type
      let formDate = date;
      if (requestType.toLowerCase() === 'early_departure' || requestType.toLowerCase() === 'late_entry') {
        // For early departure and late entry, use fromDate or toDate (they're usually the same)
        formDate = fromDate || toDate || date;
      } else if (requestType.toLowerCase() === 'leave') {
        // For leave, use fromDate
        formDate = fromDate || date;
      }

      setForm({
        requestType: requestType.toLowerCase().replace(/\s+/g, '_'), // normalize to 'late_entry', 'leave', etc.
        reason,
        date: convertDateFormat(formDate),
        fromDate: convertDateFormat(fromDate),
        toDate: convertDateFormat(toDate),
        fromTime,
        toTime,
        numberOfDays: numberOfDays ? String(numberOfDays) : ''
      });
    } else if (!edit && open) {
      // Reset form when opening in create mode
      setForm({
        requestType: '',
        reason: '',
        date: '',
        fromTime: '',
        toTime: '',
        numberOfDays: '',
        fromDate: '',
        toDate: ''
      });
    }
  }, [edit, selectedData, open]);

  const tokenUser = React.useMemo(() => {
    const token = Cookies.get('Token');
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded || null;
    } catch (e) {
      return null;
    }
  }, []);

  const displayName = React.useMemo(() => {
    const firstFromCookie = currentUser?.firstname || currentUser?.firstName;
    const lastFromCookie = currentUser?.lastname || currentUser?.lastName;
    if (firstFromCookie) {
      return lastFromCookie ? `${firstFromCookie} ${lastFromCookie}` : firstFromCookie;
    }
    const firstFromToken = tokenUser?.firstname || tokenUser?.firstName;
    const lastFromToken = tokenUser?.lastname || tokenUser?.lastName;
    if (firstFromToken) {
      return lastFromToken ? `${firstFromToken} ${lastFromToken}` : firstFromToken;
    }
    return tokenUser?.student?.name || tokenUser?.name || currentUser?.name || currentUser?.fullName || currentUser?.student?.name || '—';
  }, [currentUser, tokenUser]);

  const displayUid = React.useMemo(() => {
    return tokenUser?.student?.uid || tokenUser?.uid || currentUser?.uid || currentUser?.studentId || currentUser?.student?.uid || '—';
  }, [currentUser, tokenUser]);

  const clearFieldError = (key) => {
    setFieldErrors((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const handleChange = (key, value) => {
    clearFieldError(key);
    if (key === 'requestType') {
      setFieldErrors({});
    }
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const validateForm = (normalizedType) => {
    const errors = {};

    if (!form.requestType) {
      errors.requestType = 'Please select a request type';
    }

    if (!form.reason || !form.reason.trim()) {
      errors.reason = 'Reason is required';
    }

    const isLeave = normalizedType === 'leave';
    const isLateEntry = normalizedType === 'late_entry';
    const isEarlyDeparture = normalizedType === 'early_departure';

    if (isLeave) {
      if (!form.fromDate) {
        errors.fromDate = 'Please select from date';
      }
      if (!form.toDate) {
        errors.toDate = 'Please select expected arrival date';
      }
      if (form.fromDate && form.toDate) {
        const from = new Date(form.fromDate);
        const to = new Date(form.toDate);
        if (to < from) {
          errors.toDate = 'Arrival date cannot be before from date';
        }
      }
    } else {
      if (!form.date) {
        errors.date = 'Please select a date';
      }
      if (!form.toTime) {
        errors.toTime = `Please select ${isLateEntry ? 'expected arrival' : 'expected departure'} time`;
      }
    }

    setFieldErrors(errors);
    if (Object.keys(errors).length > 0) {
      return { valid: false, message: Object.values(errors)[0] };
    }
    return { valid: true };
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = Cookies.get('Token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `${process.env.REACT_APP_BACKEND_URL}/gate_pass/add`;

    // Normalize requestType to API slugs
    const typeLower = String(form.requestType || '').toLowerCase();
    const normalizedType =
      typeLower === 'leave' ? 'leave' : typeLower === 'late_entry' || typeLower === 'late entry' ? 'late_entry' : typeLower;
    const trimmedReason = form.reason?.trim() || '';

    // Construct payload as API expects (fromDate required)
    const isLeave = normalizedType === 'leave';
    const isLateEntry = normalizedType === 'late_entry';
    const isEarlyDeparture = normalizedType === 'early_departure';

    const validationResult = validateForm(normalizedType);
    if (!validationResult.valid) return;

    const currentTimeString = new Date().toISOString().slice(11, 16); // "HH:mm"

    const to24 = (time) => {
      const converted = convertTo24Hour(time || '');
      return converted === '00:00' ? '24:00' : converted;
    };

    // Build payload based on edit mode or create mode
    let payload;
    if (edit && isLeave) {
      // Edit mode for leave: use API format with outTime and inTime
      payload = {
        requestType: normalizedType,
        fromDate: form.fromDate,
        toDate: form.toDate,
        reason: trimmedReason,
        outTime: form.fromTime ? to24(form.fromTime) : '09:00', // Default if not provided
        inTime: form.toTime ? to24(form.toTime) : '18:00' // Default if not provided
      };
    } else if (edit) {
      // Edit mode for other types (late_entry, early_departure)
      if (isLateEntry) {
        // Late entry uses toTime
        const toTimeValue = form.toTime ? to24(form.toTime) : '18:00';
        payload = {
          requestType: normalizedType,
          fromDate: form.date,
          reason: trimmedReason,
          toTime: toTimeValue
        };
      } else if (isEarlyDeparture) {
        // Early departure payload expected by API
        const toTimeValue = form.toTime ? to24(form.toTime) : '18:00';
        payload = {
          requestType: normalizedType,
          reason: trimmedReason,
          toDate: form.date,
          toTime: toTimeValue
        };
      } else {
        // Fallback for other types
        payload = {
          requestType: normalizedType,
          fromDate: form.date,
          reason: trimmedReason,
          fromTime: form.fromTime ? to24(form.fromTime) : currentTimeString,
          toTime: form.toTime ? to24(form.toTime) : currentTimeString
        };
      }
    } else if (isLeave) {
      // Create mode for leave
      payload = {
        studentId: Cookies.get('_Id'),
        requestType: normalizedType,
        reason: trimmedReason,
        fromDate: form.fromDate,
        toDate: form.toDate,
        numberOfDays: form.numberOfDays ? Number(form.numberOfDays) : undefined
      };
    } else {
      // Create mode for other types
      payload = {
        studentId: Cookies.get('_Id'),
        requestType: normalizedType,
        reason: trimmedReason,
        fromDate: form.date,
        fromTime: isLateEntry ? currentTime : to24(form.fromTime),
        toTime: to24(form.toTime)
      };
    }

    // Additional validation for required fields per type
    if (isLeave) {
      if (!payload.fromDate || !payload.toDate) {
        toast.error('Please select From Date and To Date');
        return;
      }
      // For edit mode, validate outTime and inTime
      if (edit && (!payload.outTime || !payload.inTime)) {
        toast.error('Please provide Out Time and In Time');
        return;
      }
    } else if (isEarlyDeparture) {
      // Construct payload for early departure
      if (!edit) {
        payload.toDate = form.date;
        payload.toTime = to24(form.toTime || currentTime);
        payload.reason = form.reason;
      }
      // For edit mode, validate toDate and toTime
      if (edit && (!payload.toDate || !payload.toTime)) {
        toast.error('Please select Date and Expected Departure Time');
        return;
      }
    } else {
      // For late entry and other types
      if (edit) {
        // Edit mode: late entry uses toTime, early departure uses outTime and inTime
        if (isLateEntry) {
          if (!payload.fromDate || !payload.toTime) {
            toast.error('Please select Date and Expected Arrival Time');
            return;
          }
        } else if (isEarlyDeparture) {
          if (!payload.toDate || !payload.toTime) {
            toast.error('Please select Date and Expected Departure Time');
            return;
          }
        }
      } else {
        // Create mode uses fromTime and toTime
        if (!payload.fromDate || !payload.fromTime || !payload.toTime) {
          toast.error('Please select Date, From Time and To Time');
          return;
        }
      }
    }

    try {
      setSubmitting(true);

      // If parent provided onSubmit, validate first; only hit API on success
      if (onSubmit) {
        const prelim = await onSubmit(payload);
        const ok = prelim?.success !== false;
        if (!ok) {
          return; // stop if validation failed
        }
      }

      // Use PUT for edit mode, POST for create mode
      let res;
      const requestId = selectedData?._id || selectedData?.requestId; // Use _id (mapped from API's 'id')
      const isEditMode = edit === true && selectedData && requestId;
      
      console.log('API call check:', { 
        edit, 
        selectedData, 
        has_Id: !!selectedData?._id, 
        hasRequestId: !!selectedData?.requestId,
        requestId,
        isEditMode 
      });
      
      if (isEditMode) {
        // Update existing request - use the edit endpoint
        const updateUrl = `${process.env.REACT_APP_BACKEND_URL}/gate_pass/edit-gatepass/${requestId}`;
        console.log('Calling EDIT API:', updateUrl, 'Payload:', payload);
        res = await axios.put(updateUrl, payload, { headers });
      } else {
        // Create new request
        console.log('Calling CREATE API:', url, 'Payload:', payload);
        res = await axios.post(url, payload, { headers });
      }
      const data = res?.data?.data || {};

      const result = {
        success: true,
        data: {
          requestId: data?.requestId || data?.id || data?._id, // API returns 'id', map to requestId
          status: data?.status || 'pending',
          requestType: data?.requestType || normalizedType,
          date: data?.date || (isLeave ? `${form.fromDate}${form.toDate ? ` to ${form.toDate}` : ''}` : form.date),
          fromTime: data?.fromTime || form.fromTime,
          toTime: data?.toTime || form.toTime,
          reason: data?.reason || form.reason
        }
      };
      const isSuccess = result?.success !== false; // treat undefined as success
      if (isSuccess) {
        if (edit) {
          // For edit mode: close modal, refresh data, show success toast
          if (onClose) onClose();
          if (fetchRequests) {
            fetchRequests();
          }
          toast.success('Gate pass request updated successfully');
        } else {
          // For create mode: show success modal
          const payload = result?.data || {
            requestId: res.data?.requestId || res.data?.id || res.data?._id, // API returns 'id', map to requestId
            status: 'Pending',
            requestType: form.requestType,
            date: form.date,
            fromTime: to24(form.fromTime),
            toTime: to24(form.toTime),
            reason: trimmedReason,
            use24Hour: true
          };
          setSuccessData(payload);
          setShowSuccess(true);
          if (onClose) onClose();
        }
      }
    } catch (error) {
      const serverMessage = error?.response?.data?.message || error?.message || 'Failed to submit request';
      console.error('Gate pass submit error:', error?.response?.data || error);
      toast.error(serverMessage);
      return;
    } finally {
      setSubmitting(false);
    }
  };
   

  const fetchStudentData = async () => {
    const token = Cookies.get('Token') || '';
    const response = await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/room/room-detail`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        console.log('Response ->', response);
        setStudentData(response.data?.data);
      })
      .catch((error) => {
        console.log('Error', error);
        toast.error(error.response.data.message);
      });
  };
  React.useEffect(() => {
    fetchStudentData();
  }, []);

  useEffect(() => {
    if (form.fromDate && form.toDate) {
      const from = new Date(form.fromDate);
      const to = new Date(form.toDate);

      // Calculate difference in days (inclusive)
      const diffInMs = to - from;
      const diffInDays = diffInMs >= 0 ? Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1 : 0;

      // Update only if value changed
      setForm((prev) => (prev.numberOfDays !== diffInDays ? { ...prev, numberOfDays: diffInDays } : prev));
    } else {
      // Clear number of days when one of the dates is missing
      setForm((prev) => (prev.numberOfDays ? { ...prev, numberOfDays: '' } : prev));
    }
  }, [form.fromDate, form.toDate]);

  const modalMarkup = !open
    ? null
    : ReactDOM.createPortal(
        <div className={styles.backdrop}>
          <div className={styles.modal} role="dialog" aria-modal="true">
            <div className={styles.header}>
              <Typography className={styles.title}>{edit ? 'Edit Gate Pass Request' : 'Submit New Gate Pass Request'}</Typography>
              <IconButton onClick={onClose} size="small" aria-label="Close">
                <X size={20} />
              </IconButton>
            </div>

            <div className={styles.content}>
              <section className={styles.section}>
                <Typography className={styles.sectionTitle}>Student Information</Typography>
                <div className={styles.infoGrid}>
                  <div>
                    <p className={styles.label}>Student Name</p>
                    <p className={styles.value} style={{ textTransform: 'capitalize' }}>
                      {displayName}
                    </p>
                  </div>
                  <div>
                    <p className={styles.label}>UID</p>
                    <p className={styles.value}>{displayUid}</p>
                  </div>
                  <div>
                    <p className={styles.label}>Building No.</p>
                    <p className={styles.value}>{studentData?.building_no || 'Not Available (N/A)'}</p>
                  </div>
                  <div>
                    <p className={styles.label}>Room Number</p>
                    <p className={styles.value}>{studentData?.roomNo || studentData?.roomNumber || studentData?.room?.number || 'Not Available (N/A)'}</p>
                  </div>
                </div>
              </section>

              <section className={styles.section}>
                <Typography className={styles.sectionTitle}>Request Details</Typography>
                <div className={styles.fieldColumn}>
                  <Typography className={styles.sectionReason}>
                    Request Type<span className={styles.required}>*</span>
                  </Typography>
                  <TextField
                    select
                    value={form.requestType}
                    onChange={(e) => handleChange('requestType', e.target.value)}
                    fullWidth
                    size="small"
                    error={Boolean(fieldErrors.requestType)}
                    helperText={fieldErrors.requestType}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (selected) => {
                        if (!selected) return <span style={{ color: '#9CA3AF' }}>Select Request Type</span>;
                        if (selected === 'late_entry') return 'Late Entry';
                        if (selected === 'leave') return 'Leave';
                        if (selected === 'early_departure') return 'Early Departure';
                        return selected;
                      }
                    }}
                    sx={{
                      '& .MuiSelect-select.MuiInputBase-input': {
                        color: form.requestType ? '#1F2937' : '#9CA3AF'
                      }
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Request Type
                    </MenuItem>
                    <MenuItem value="late_entry">Late Entry</MenuItem>
                    <MenuItem value="leave">Leave</MenuItem>
                    <MenuItem value="early_departure">Early Departure</MenuItem>
                  </TextField>

                  <Typography className={styles.sectionReason}>
                    Reason for Request<span className={styles.required}>*</span>
                  </Typography>
                  <TextField
                    // label="Reason for Request"
                    placeholder="Please provide a detailed reason for your request.."
                    value={form.reason}
                    onChange={(e) => handleChange('reason', e.target.value)}
                    fullWidth
                    size="small"
                    multiline
                    minRows={4}
                    error={Boolean(fieldErrors.reason)}
                    helperText={fieldErrors.reason}
                    sx={{
                      '& .MuiInputBase-input::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1
                      },
                      '& textarea::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1
                      }
                    }}
                  />
                </div>
              </section>

              <section className={styles.section}>
                <Typography className={styles.sectionTitle}>
                  {form.requestType === 'leave' ? 'Leave Details' : 'Date and Time Details'}
                </Typography>

                <div className={styles.timeGrid}>
                  {form.requestType !== 'leave' && (
                    <TextField
                      label="Date"
                      type="date"
                      value={form.date}
                      onChange={(e) => handleChange('date', e.target.value)}
                      fullWidth
                      size="small"
                      placeholder="dd/mm/yyyy"
                      className={styles.roundedInput}
                      error={Boolean(fieldErrors.date)}
                      helperText={fieldErrors.date}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: new Date().toISOString().split('T')[0] }}
                    />
                  )}

                  {form.requestType === 'leave' ? (
                    <>
                      <TextField
                        label="From Date"
                        type="date"
                        value={form.fromDate || ''}
                        onChange={(e) => handleChange('fromDate', e.target.value)}
                        fullWidth
                        size="small"
                        className={styles.roundedInput}
                      error={Boolean(fieldErrors.fromDate)}
                      helperText={fieldErrors.fromDate}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ min: new Date().toISOString().split('T')[0] }}
                      />
                      <TextField
                        label="Expected Arrival Date"
                        type="date"
                        value={form.toDate || ''}
                        onChange={(e) => handleChange('toDate', e.target.value)}
                        fullWidth
                        size="small"
                        className={styles.roundedInput}
                      error={Boolean(fieldErrors.toDate)}
                      helperText={fieldErrors.toDate}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ min: new Date().toISOString().split('T')[0] }}
                      />
                      <TextField
                        label="Number of Days"
                        type="number"
                        value={form.numberOfDays || ''}
                        fullWidth
                        size="small"
                        className={styles.roundedInput}
                        inputProps={{ readOnly: true }}
                      />
                    </>
                  ) : (
                    <>
                      <TextField
                        style={{ display: 'none' }}
                        label="From Time"
                        type="time"
                        value={form.fromTime}
                        onChange={(e) => handleChange('fromTime', e.target.value)}
                        fullWidth
                        size="small"
                        placeholder="---"
                        className={styles.roundedInput}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          step: 300,
                          min: isToday ? currentTime : undefined // ✅ Restrict time if today
                        }}
                      />

                      <TextField
                        label={form.requestType === 'late_entry' ? 'Expected Arrival Time' : 'Expected Departure Time'}
                        type="time"
                        value={form.toTime}
                        onChange={(e) => handleChange('toTime', e.target.value)}
                        fullWidth
                        size="small"
                        placeholder="---"
                        className={styles.roundedInput}
                      error={Boolean(fieldErrors.toTime)}
                      helperText={fieldErrors.toTime}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          step: 300,
                          min:
                            isToday && form.fromTime
                              ? form.fromTime // ✅ Expected arrival must be after From Time
                              : isToday
                              ? currentTime
                              : undefined
                        }}
                      />
                    </>
                  )}
                </div>
              </section>
            </div>

            <div className={styles.footer}>
              <Button onClick={onClose} variant="outlined" className={styles.cancelBtn}>
                Cancel
              </Button>
              <Button onClick={handleSubmit} disabled={submitting} variant="contained" className={styles.submitBtn}>
                {edit ? 'Update Request' : 'Submit Request'}
              </Button>
            </div>
          </div>
        </div>,
        document.body
      );

  return (
    <>
      {modalMarkup}
      <GateRequestSuccessModal
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        onDashboard={() => setShowSuccess(false)}
        data={successData}
      />
    </>
  );
};

export default GateRequestModal;
